"use client";

import { useUrlDrawer } from "@nimble/react-state-hooks/use-url-drawer";

export default function useSignUpDrawer() {
  return useUrlDrawer({
    paramName: "signup",
  });
}
